var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar'),(_vm.step===1)?_c('Main',{on:{"done":_vm.next}}):_vm._e(),(_vm.step===2)?_c('PDFView',{attrs:{"preview":_vm.preview,"numPages":_vm.numPages},on:{"done":_vm.prev}}):_vm._e(),(_vm.step===2)?_c('Comments'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }